import $ from 'jquery';


$('.popup-tabs__item').click(function () {
    if ($(this).hasClass('popup-tabs__item--active')) {
        return false;
    }
    const tab = $(this).attr('data-tab');

    // switch buttons
    $('.popup-tabs__item').removeClass('popup-tabs__item--active');
    $(this).addClass('popup-tabs__item--active');

    // switch tabs
    $('.popup-tab').hide();
    $(`.popup-tab--${tab}`).fadeIn();

    return true;
});
